import { createContext, useContext, useState } from 'react'

export const SITES = [
  {
    id: 'pdk',
    name: 'Pejabat Daerah Kuching',
    shortName: 'PDK',
    description: 'District Office · Kuching',
    colorClass: 'site-blue',
    icon: 'building-community',
  },
  {
    id: 'jks',
    name: 'Jabatan Kesihatan Sarawak',
    shortName: 'JKS',
    description: 'Health Dept · Sarawak',
    colorClass: 'site-green',
    icon: 'heart-rate-monitor',
  },
  {
    id: 'mbku',
    name: 'Majlis Bandaraya Kuching Utara',
    shortName: 'MBKU',
    description: 'City Council · North Kuching',
    colorClass: 'site-amber',
    icon: 'map-pin',
  },
  {
    id: 'jps',
    name: 'Jabatan Pendidikan Sarawak',
    shortName: 'JPS',
    description: 'Education Dept · Sarawak',
    colorClass: 'site-purple',
    icon: 'student',
  },
]

const SiteContext = createContext(null)

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null)

  return (
    <SiteContext.Provider value={{ site, setSite, sites: SITES }}>
      {children}
    </SiteContext.Provider>
  )
}

export function useSite() {
  return useContext(SiteContext)
}
